import { Selector } from "@reduxjs/toolkit";

import { ModulFState } from "../store";

export function getFilterByKategorie(activityId: string): Selector<ModulFState, boolean> {
	return state => state.textbausteine.showAllKategorie[activityId] ?? false;
}
